import {Component, Injector, OnInit} from "@angular/core";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {FormArray, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NewCertificationService} from "./services/new-certification.service";
import {AssociationService} from "../associactions/services/association.service";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-new-certification-domain-form',
    templateUrl: './new-certification-domain-form.component.html',
    styleUrls: ['../../scss/office.scss']
})
export class NewCertificationDomainFormComponent extends BaseComponentDirective implements OnInit {
    public form: FormGroup;

    associations: any[] = [];
    certification: any = null;

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private certificationService: NewCertificationService,
        private associationService: AssociationService
    ) {
        super(injector);
        this.form = this.formBuilder.group({
            certificationTitle: [null, [Validators.required]],
            providerId: [null, [Validators.required]],
            domains: this.formBuilder.array([]),
        });

        this.addDomain();
    }

    get domains(): FormArray {
        return this.form.get('domains') as FormArray;
    }

    objectives(domainIndex: number): FormArray {
        return this.domains.at(domainIndex).get('objectives') as FormArray;
    }

    addDomain() {
        const domainFG = this.formBuilder.group({
            domainName: [null, [Validators.required]],
            objectives: this.formBuilder.array([]),
        })
        this.domains.push(domainFG);
        this.addObjective(this.domains.length - 1);
    }

    removeDomain(i: number) {
        if(this.domains.length > 1) {
            this.domains.removeAt(i);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining domain');
            return;
        }
    }

    addObjective(domainIndex: number) {
        const objectiveFG = this.formBuilder.group({
            objectiveName: [null, [Validators.required]],
            term: [null, [Validators.required]],
        });

        this.objectives(domainIndex).push(objectiveFG);
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        this.associations = await this.associationService.getAllNoPaging();
        this.certification = await this.certificationService.getById(this.activatedRoute.snapshot.params.certificationId);

        this.form.controls.certificationTitle.setValue(this.certification.certificationTitle);
        this.form.controls.providerId.setValue(this.certification.association.id);

        this.form.controls.certificationTitle.disable();
        this.form.controls.providerId.disable();

    }

    removeObjective(domainIndex: number, objectiveIndex: number) {
        const objectives = this.domains.at(domainIndex).get('objectives') as FormArray;
        if(objectives.length > 1) {
            objectives.removeAt(objectiveIndex);
        } else {
            this.showAlertDark('Warning', '', 'Cannot delete last remaining objective');
            return;
        }
    }

    saveDomain() {
        const validation = this.check(this.form);
        if (validation) {
            this.showAlertDark('Warning', '', 'Please complete all required fields.');
            return;
        }

        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '800px';
        const confirm = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: "Add New Certification Domain",
                subMessage: "Are you sure want to add new certification domain?",
                buttonOkLabel: 'Yes, Save',
                buttonCancelLabel: 'Cancel',
                theme: 'dark'
            }
        });
        confirm.componentInstance.result.subscribe(r => {
            if(r) {

                let payload = this.form.value;
                payload['id'] = this.certification.id;
                payload['certificationTitle'] = this.certification.certificationTitle;
                payload['providerId'] = this.certification.association.id;

                this.certificationService.saveCertificationDomain(this.form.value, this.certification.id).then(_ => {
                    this.showSnackbarDark('Certification Domain', 'Certification domain has been added successfully', '');
                    this.router.navigate([`/office/new-certification/detail/${this.certification.id}`], {queryParams: {tab: 'domains'}}).then();
                })
            }
        })
    }

}
